import React, { useEffect, useState } from "react";
// import SectionHeading from "../SectionHeading/SectionHeading";

const api = "AIzaSyBiNSppdp9mrw_NCMLr2aG2M-k0a5hmE_o";
const channelId = "UCzjtEsnXEIY0XTH_krchs0A";
const fetchUrl = `https://www.googleapis.com/youtube/v3/search?key=${api}&channelId=${channelId}&part=snippet,id&order=date&maxResults=20`;

const videoData = [
  {
    VideoLink: "https://www.youtube.com/embed/eQ3VBrAd4hI",
    title:
      "Understanding Male Infertility | male infertility causes | testosterone | Dr. Archana Shrivastava",
    publishedAt: "2025-05-09T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/UFRmMDniLbk",
    title:
      "Primary factor of infertility | Male | Female | Dr. Archana Shrivastava | Pluro Jabalpur Fertility Centre",
    publishedAt: "2025-05-08T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/GKc1PJA04yw",
    title:
      "Infertile couple | Causes of infertility | Fertility solutions | OPD | Dr. Archana Shrivastava",
    publishedAt: "2025-05-07T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/yazy36SHbVE",
    title:
      "Patient Story | IVF Story | Gynaecologist | IVF Specialist | Dr. Archana Shrivastava | Awareness",
    publishedAt: "2025-04-23T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/46nyueKjX1M",
    title:
      "7 साल का इंतज़ार हुआ खत्म | माता-पिता बनने का सुख | डॉ. अर्चना श्रीवास्तव | जबलपुर फर्टिलिटी सेंटर",
    publishedAt: "2025-04-08T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/hlRdznUBXq4",
    title:
      "9 साल का इंतज़ार, खुशियों की सौगात | डॉ. अर्चना श्रीवास्तव | जबलपुर फर्टिलिटी सेंटर | जबलपुर",
    publishedAt: "2025-04-05T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/5vqtECIz6T4",
    title: "24 साल की उम्मीद, एक खूबसूरत चमत्कार! ✨👶",
    publishedAt: "2025-04-04T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/SStIVA44KHM",
    title:
      "She never expected her journey to lead to IVF | Dr. Archana Shrivastava | Pluro Jabalpur Fertility Centre",
    publishedAt: "2025-03-18T00:00:00Z",
  },
  {
    VideoLink: "https://www.youtube.com/embed/LbMWZLYg32w",
    title:
      "Parenthood Should Be a Choice, Not a Chance | Dr. Archana Shrivastava | Pluro Jabalpur Fertility Centre",
    publishedAt: "2025-03-11T00:00:00Z",
  },
];

const AttendLiveEvents = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const resJson = await response.json();
        console.log("API Response:", resJson);
        const result = resJson.items.map((doc) => ({
          ...doc,
          VideoLink: "https://www.youtube.com/embed/" + doc.id.videoId,
          publishedAt: doc.snippet.publishedAt,
          title: doc.snippet.title,
        }));
        setVideos(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const truncateTitle = (title, maxLength) => {
    if (title.length <= maxLength) {
      return title;
    }
    return title.substring(0, maxLength) + "...";
  };

  const videosToShow = videos.slice(0, 3);
  const fallbackVideos = videoData.slice(0, 3);
  const displayVideos = videosToShow.length ? videosToShow : fallbackVideos;

  return (
    <div className="container">
      <div className="row">
        {displayVideos.map((video, index) => (
          <div className="col-lg-4 col-md-6" key={index}>
            <div className="cs_premium_post_card">
              <div className="cs_post_video_wrap">
                <iframe
                  className="embed-responsive-item"
                  width="100%"
                  height="300px"
                  allowFullScreen
                  src={video.VideoLink}
                  title={`YouTube video player ${index + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                ></iframe>
              </div>
              <div className="cs_post_content">
                <div className="cs_post_meta">
                  <span className="cs_post_date">{formatDate(video.publishedAt)}</span>
                </div>
                <h3 className="cs_post_title">{truncateTitle(video.title, 50)}</h3>
                <div className="cs_post_author">
                  <div className="cs_author_avatar">
                    AS
                  </div>
                  <div className="cs_author_info">
                    <span className="cs_author_name">Dr. Archana Shrivastava</span>
                    <span className="cs_author_title">Fertility Expert</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const PostWrapper = ({ data }) => {
  return (
    <section id="blog">
      <div className="st-height-b120 st-height-lg-b80" />
      {/* <SectionHeading
        title="Latest News"
        subTitle="Stay updated with our latest news: breakthroughs, events, and insights. <br /> Explore the forefront of innovation and stay informed."
      /> */}
      <div className="container">
        <div className="row">
          <AttendLiveEvents />
          <div className="st-height-b120 st-height-lg-b80" />
        </div>
      </div>
    </section>
  );
};

export default PostWrapper;
